import SearchContainer from 'components/pages/Search/SearchContainer';

const Search = () => {

  return (
   <SearchContainer />
  );
};

export default Search;